import Button from 'assets/components/button/Button';
import ThemeButtonCircle from 'assets/components/button/themes/Theme.Button.Circle';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import Page from 'assets/components/page/Page';
import ThemePageError from 'assets/components/page/themes/Theme.Page.Error';
import ThemeTableSimple from 'assets/components/table/themes/Theme.Table.Simple';
import { getLocales } from 'assets/locales/Locale';
import {
  PricingDistributionMasterTemplateAction,
  usePricingDistributionMasterTemplateProvider,
} from '../PricingDistributionMasterTemplate.Hooks';

export default function PricingDistributionMasterTemplateList() {
  const { lang } = getLocales();
  const { listApi, pageRouter, permissions } = usePricingDistributionMasterTemplateProvider();

  return !listApi.payload && !listApi.isExecuting && listApi.apiCounter > 0 ? (
    <Page
      class={ThemePageError}
      sidebar={<Icon class="fas-clipboard-list" />}
      header={lang.vehicles}
      render={lang.noInfo}
    />
  ) : (
    <table className={ThemeTableSimple}>
      <thead>
        <tr>
          <th>{lang.name}</th>
          <th>{lang.description}</th>
          <th data-actions>{lang.actions}</th>
        </tr>
      </thead>
      <tbody>
        <DataMap
          data={listApi.payload?.data}
          render={({ data: distribution }) => (
            <tr key={distribution?.id}>
              <td>
                <b>{distribution.name}</b>
              </td>
              <td>{distribution.description}</td>

              <td>
                <Button
                  onClick={pageRouter.updateParams}
                  data={{
                    id: distribution?.id.toString(),
                    action: PricingDistributionMasterTemplateAction.EDIT,
                  }}
                  disabled={!permissions.ACCESS_PRICINGDISTRIBUTIONMASTERTEMPLATE}
                  class={ThemeButtonCircle}
                  media={<Icon class="fas-edit" />}
                  htmlElementProps={{ title: lang.edit }}
                  active
                />
              </td>
            </tr>
          )}
        />
      </tbody>
    </table>
  );
}
